<app-comments-on-entity
    [entityType] = "data.entityType"
    [entityKeyValue] = "data.entityKeyValue"
></app-comments-on-entity>